import React from 'react';
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';

import type useDownloadReportForm from '../../hooks/useDownloadReportForm';

import Switch from '../../../_ui/Form/Switch/Switch';
import Typography from '../../../_ui/Typography/Typography';
import DatePicker from '../../../_ui/Form/DateInput/DateInput';

type UseDownloadReportFormReturnType = ReturnType<typeof useDownloadReportForm>;

dayjs.extend(customParseFormat);

interface Props extends Pick<UseDownloadReportFormReturnType, 'formData' | 'setFormData'> {
    errorMessage?: string;
}

export default function DateRange({ formData, setFormData, errorMessage }: Props) {
    const setLast30Days = (value: boolean) => {
        setFormData({
            ...formData,
            last30days: value,
        });
    }

    const setStartDate = (value: Date | null) => {
        setFormData({
            ...formData,
            start_date: dayjs(value).format('YYYY-MM-DDTHH:mm:ss'),
        });
    }

    const setEndDate = (value: Date | null) => {
        setFormData({
            ...formData,
            end_date: dayjs(value).format('YYYY-MM-DDTHH:mm:ss'),
        });
    }

    return (
        <fieldset className="space-y-050">
            <legend className="type-small-caps">Date range</legend>
            <div className="flex justify-between gap-100">
                <span className={formData.last30days ? '' : 'opacity-25'}>Download the last 30 days</span>
                <Switch isOn={formData.last30days} onChange={setLast30Days} label="Use custom date range" />
            </div>
            <div className={`flex gap-050 justify-between items-center relative z-[110] ${formData.last30days ? 'opacity-25 pointer-events-none' : ''}`}>
                <Typography as="div" variant="meta" className="flex-shrink-0">Start date</Typography>
                <DatePicker
                    id="start_date"
                    classOverrides="!w-auto mr-200"
                    placeholderText="DD-MM-YYY"
                    onChange={setStartDate}
                    disabled={formData.last30days}
                />
            </div>
            <div className={`flex gap-050 justify-between items-center ${formData.last30days ? 'opacity-25 pointer-events-none' : ''}`}>
                <Typography as="div" variant="meta" className="flex-shrink-0">End date</Typography>
                <DatePicker
                    id="end_date"
                    classOverrides="!w-auto mr-200"
                    placeholderText="DD-MM-YYY"
                    onChange={setEndDate}
                    disabled={formData.last30days}
                />
            </div>
            {errorMessage ? (
                <Typography as="div" variant="meta" color="error">
                    {errorMessage}
                </Typography>
            ) : null}
        </fieldset>
    );
};
